module.exports = __webpack_public_path__ + "img/arrow_up.4af92010-da9ef403.3542069e.svg";